const PracticeProfileFieldKeys = {
  PRACTICE_NAME: 'practiceName',
  PRACTICE_SHORT_CODE: 'practiceId',
  CREATED_AT: 'createdAt',
  UPDATED_AT: 'updatedAt',
  PARTNER_NAME: 'partnerName',
};

export default PracticeProfileFieldKeys;
